import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const GetRevenueForecastResponseDtoSchema = z.object({
  actuals: z.array(
    z.object({
      month: z.string(),
      value: z.number(),
    })
  ),
  forecast: z.array(
    z.object({
      month: z.string(),
      value: z.number(),
    })
  ),
});

const _GetRevenueForecastRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
});

export type GetRevenueForecastResponseDto = z.infer<
  typeof GetRevenueForecastResponseDtoSchema
>;
export type GetRevenueForecastRequestDto = z.infer<
  typeof _GetRevenueForecastRequestDtoSchema
>;

export const getRevenueForecast = (
  params: GetRevenueForecastRequestDto,
  config?: AxiosRequestConfig<GetRevenueForecastRequestDto>
) => {
  return api
    .get('facilities/revenue-forecast', { params, ...config })
    .then(responseContract(GetRevenueForecastResponseDtoSchema));
};
